import { Instance } from 'mobx-state-tree'
import { UserAdditionalDetailsModelBase } from './UserAdditionalDetailsModel.base'

/* The TypeScript type of an instance of UserAdditionalDetailsModel */
export interface UserAdditionalDetailsModelType extends Instance<typeof UserAdditionalDetailsModel.Type> {}

/* A graphql query fragment builders for UserAdditionalDetailsModel */
export {
  selectFromUserAdditionalDetails,
  userAdditionalDetailsModelPrimitives,
  UserAdditionalDetailsModelSelector
} from './UserAdditionalDetailsModel.base'

/**
 * UserAdditionalDetailsModel
 */
export const UserAdditionalDetailsModel = UserAdditionalDetailsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
